import type { ReplayFxMode } from './replayFxCues'

export const REPLAY_FX_LAYER_ORDER = [
  'backdrop',
  'shutters',
  'tube',
  'phosphor',
  'static',
  'scanlines',
  'dataRails',
  'electricField',
  'techFrame',
  'chromatic',
  'horizon',
  'vignette',
] as const

export type ReplayFxLayerId = typeof REPLAY_FX_LAYER_ORDER[number]

export const REPLAY_FX_LAYER_LABELS: Record<ReplayFxLayerId, string> = {
  backdrop: 'Backdrop',
  shutters: 'Shutters',
  tube: 'Tube glow',
  phosphor: 'Phosphor',
  static: 'Static',
  scanlines: 'Scanlines',
  dataRails: 'Data rails',
  electricField: 'Electric',
  techFrame: 'Tech frame',
  chromatic: 'Chromatic',
  horizon: 'Horizon',
  vignette: 'Vignette',
}

// July trim: only the TV turn-on (boot), the slow loading darkening and the
// eye-opening launch survive — and each keeps just its load-bearing layers.
// Vignette is retired everywhere (per review), as are the busy garnish
// layers (static / rails / electric / frame / chromatic / horizon). The
// seek / impact / end modes are no longer routed to by the cue map.
export const REPLAY_FX_MODE_LAYERS: Record<ReplayFxMode, ReadonlySet<ReplayFxLayerId>> = {
  idle: new Set(),
  boot: new Set(['backdrop', 'shutters', 'tube', 'phosphor', 'scanlines']),
  // loading keeps the shutters as slim cinematic letterbox bars
  loading: new Set(['backdrop', 'shutters']),
  prefetch: new Set(['backdrop', 'shutters']),
  prewarm: new Set(['backdrop', 'shutters']),
  settle: new Set(['backdrop', 'shutters']),
  launch: new Set(['backdrop', 'shutters', 'tube', 'phosphor', 'scanlines']),
  seek: new Set(),
  impact: new Set(),
  end: new Set(),
}
